// IframeDeletePlugin.js
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";
import { $isIframeNode } from "./IframeNode"; // adjust path

export default function IframeDeletePlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const handleClick = (e) => {
      const closeBtn = e.target.closest(".iframe_node_close");
      if (!closeBtn) return;

      const nodeKey = closeBtn.dataset.nodeKey;
      if (!nodeKey) return;

      editor.update(() => {
        const node = $getNodeByKey(nodeKey);
        if (node && $isIframeNode(node)) {
          node.remove();
        }
      });
    };

    // attach to editor DOM
    const editorEl = editor.getRootElement();
    if (editorEl) {
      editorEl.addEventListener("click", handleClick);
    }

    return () => {
      const editorEl = editor.getRootElement();
      if (editorEl) {
        editorEl.removeEventListener("click", handleClick);
      }
    };
  }, [editor]);

  return null;
}